import ChangePassword from './ChangePassword';
import ChangePasswordForm from './ChangePasswordForm';
export { ChangePassword, ChangePasswordForm };
export default ChangePassword;
